import {Component, inject, OnInit} from '@angular/core';
import {AppointmentSelectionService} from '../../appointment-selection.service';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {MemoryService} from '../../../../core/services/memory.service';
import {BreakpointObserver} from '@angular/cdk/layout';
import {LogoComponent} from '../../../../shared/components/logo/logo.component';
import {AppointmentFiltersComponent} from '../appointment-filters/appointment-filters.component';
import {MatDivider} from '@angular/material/divider';
import {DateSelectionComponent} from '../date-selection/date-selection.component';
import {TimeSelectionComponent} from '../time-selection/time-selection.component';
import {MatDialog} from '@angular/material/dialog';
import {PatientSearchComponent} from '../patient-search/patient-search.component';
import {ManagerLoginDialog} from '../../dialogs/manager-login.dialog/manager-login.dialog';

@Component({
  selector: 'app-appointment-selected-appointment',
  imports: [
    LogoComponent,
    RouterModule,
    AppointmentFiltersComponent,
    MatDivider,
    DateSelectionComponent,
    TimeSelectionComponent,
    PatientSearchComponent
  ],
  templateUrl: './appointment-selection.component.html',
  styleUrl: './appointment-selection.component.scss'
})
export class AppointmentSelectionComponent implements OnInit {
  route = inject(ActivatedRoute);
  appointmentSelectionService = inject(AppointmentSelectionService);
  memoryService = inject(MemoryService);
  router = inject(Router);
  dialog = inject(MatDialog);
  mode: 'mobile' | 'tablet' | 'desktop' = 'desktop';
  isManager: boolean = false;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver.observe([
      '(max-width: 620px)',     // mobile
      '(min-width: 621px) and (max-width: 823px)', // tablet
      '(min-width: 824px)'      // desktop
    ]).subscribe(result => {
      if (result.breakpoints['(max-width: 620px)']) {
        this.mode = 'mobile';
      } else if (result.breakpoints['(min-width: 621px) and (max-width: 823px)']) {
        this.mode = 'tablet';
      } else if (result.breakpoints['(min-width: 824px)']) {
        this.mode = 'desktop';
      }
    });
  }

  ngOnInit() {
    this.appointmentSelectionService.init();
    this.isManager = this.memoryService.isPatientManager ?? false;
    if (!this.isManager) {
      const params = this.route.snapshot.queryParams;
      const showManager = this.parseIntOrUndefined(params['ismanager']);
      if (showManager) {
        this.dialog.open(ManagerLoginDialog, {autoFocus: false}).afterClosed().subscribe((success: boolean) => {
          if (success) {
            this.isManager = true;
          }
        });
      }
    }
  }

  private parseIntOrUndefined(value: string | undefined): number | undefined {
    if (!value) {
      return undefined;
    }

    const result = parseInt(value);
    return isNaN(result) ? undefined : result;
  }
}
